import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import CopyText from '@containers/CopyText';

import CopyIcon from './copy.svg';

import style from './Invitation.scss';

const cn = bemCssModules(style, 'Invitation');
const ti = getTestId('Invitation');

export const Invitation: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [store] = useStore();
  const { data } = store.transactions.referral;

  return data?.code ? (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('link-block')}>
        <CopyText hideIcon text={`${data?.url}`}>
          <div className={cn('link-block')}>
            <div className={cn('link-block-text', ['h4'])}>{t('referral.share_your_link')}</div>
            <CopyIcon className={cn('icon')} />
          </div>
          <span className={cn('referral-link')}>{data?.url}</span>
        </CopyText>
      </div>
    </div>
  ) : null;
};

export default Invitation;
